module.exports = __webpack_public_path__ + "img/c74d450.jpg";